import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CompleteOrganizationOnboardingMutationVariables = Types.Exact<{
  organization_type: Types.Scalars['String']['input'];
  organization_name: Types.Scalars['String']['input'];
  organization_image_url?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CompleteOrganizationOnboardingMutation = { __typename?: 'mutation_root', complete_organization_onboarding?: { __typename?: 'CompleteOrganizationOnboardingOutput', success: boolean, organization_id: any, role: string } | null };


export const CompleteOrganizationOnboardingDocument = gql`
    mutation completeOrganizationOnboarding($organization_type: String!, $organization_name: String!, $organization_image_url: String) {
  complete_organization_onboarding(
    organization_type: $organization_type
    organization_name: $organization_name
    organization_image_url: $organization_image_url
  ) {
    success
    organization_id
    role
  }
}
    `;
export type CompleteOrganizationOnboardingMutationFn = Apollo.MutationFunction<CompleteOrganizationOnboardingMutation, CompleteOrganizationOnboardingMutationVariables>;

/**
 * __useCompleteOrganizationOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteOrganizationOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOrganizationOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOrganizationOnboardingMutation, { data, loading, error }] = useCompleteOrganizationOnboardingMutation({
 *   variables: {
 *      organization_type: // value for 'organization_type'
 *      organization_name: // value for 'organization_name'
 *      organization_image_url: // value for 'organization_image_url'
 *   },
 * });
 */
export function useCompleteOrganizationOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOrganizationOnboardingMutation, CompleteOrganizationOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOrganizationOnboardingMutation, CompleteOrganizationOnboardingMutationVariables>(CompleteOrganizationOnboardingDocument, options);
      }
export type CompleteOrganizationOnboardingMutationHookResult = ReturnType<typeof useCompleteOrganizationOnboardingMutation>;
export type CompleteOrganizationOnboardingMutationResult = Apollo.MutationResult<CompleteOrganizationOnboardingMutation>;
export type CompleteOrganizationOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteOrganizationOnboardingMutation, CompleteOrganizationOnboardingMutationVariables>;